<template>
  <div id="footer" class="container-fluid">
    <div class="wrap">
      <div class="contact">
        <div class="title">
          <span>联系我们</span><span class="small">Contact Us</span>
        </div>
        <div class="info">
          <div class="content">河南省人力资源开发中心有限公司</div>
          <div class="content">
            <i class="phone"></i><span>0371-61612653</span>
          </div>
          <div class="content">
            <i class="email"></i><span>hnrlzxzp@163.com</span>
          </div>
          <div class="content">
            <i class="address"></i
            ><span>郑州航空港区通航路16号 中国.中原人力资源服务产业园区</span>
          </div>
        </div>
      </div>
      <div class="guide">
        <div class="title">
          <span>快速导航</span><span class="small">Navigation</span>
        </div>
        <div class="links">
          <span
            v-for="(item, index) in ksmeun"
            :key="index"
            style="cursor: pointer"
            ><a @click="openPage(item)">{{ item.name }}</a></span
          >
          <!-- <span><a href="">服务中心</a></span>
          <span><a href="">关于我们</a></span>首 &nbsp;  &nbsp;  &nbsp; 页
          <span><a href="">公司动态</a></span>
          <span><a href="">核心业务</a></span>
          <span><a href="" @click="openPage(item)">联系我们</a></span> -->
        </div>
      </div>
      <div class="search">
        <div class="logo">
          <img src="@/assets/img/logo_white1.png" alt="logo" />
        </div>
        <div class="search-section">
          <el-input placeholder="搜索关键词" v-model="wordkey"></el-input
          ><span class="search-btn" @click="search()">搜索</span>
        </div>
      </div>
    </div>
    <div class="beian">
      <span
        ><img style="width: 16px" src="../assets/img/wangan.png" /><a
          style="color: #a3a7ab; padding-left: 2px"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41010902002119"
          target="_blank"
          >豫公网安备41010902002119号</a
        ></span
      ><span
        ><a
          href="https://beian.miit.gov.cn"
          style="color: #a3a7ab"
          target="_blank"
          >豫ICP备2023016630号-1</a
        ></span
      >
    </div>
    <div></div>
    <div class="liuyan" @click="guestbook"><span>留言</span></div>
    <!-- <p class="title">公司企业网站模板</p>
    <p class="address_tel_fax">
      <span>地址：公司地址公司地址公司地址公司地址</span>
      <span>Tel：888-888-888</span>
      <span>Fax：8888-88888888</span>
    </p>
    <p class="email_wx">
      <span>邮箱：liyunkun_11@163.com</span>
      <span>公司微信号：ilyk_gg</span>
    </p>
    <p class="copy">Copyright &copy; 2018 - 2019 公司名称公司名称</p> -->
    <div>
      <el-dialog
        title="请您留言"
        class="comments-box"
        width="500px"
        height="400px"
        center
        :visible.sync="formVisible"
      >
        <el-form :model="formData" :rules="rules" ref="myForm">
          <el-form-item required prop="content">
            <el-input
              v-model="formData.content"
              type="textarea"
              :rows="6"
              placeholder="请在此输入留言内容，我们会尽快与您联系(必填)。"
              maxlength="500"
            ></el-input>
          </el-form-item>
          <el-form-item prop="contactusname">
            <el-input
              v-model="formData.contactusname"
              placeholder="姓名"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item required prop="contactustel">
            <el-input
              v-model="formData.contactustel"
              placeholder="手机号(必填)"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item prop="contactusemail">
            <el-input
              v-model="formData.contactusemail"
              placeholder="邮箱"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code" required v-if="captchaEnabled">
            <el-input
              v-model="formData.code"
              auto-complete="off"
              placeholder="请输入验证码"
              style="width: 50%"
              maxlength="3"
            >
            </el-input>
            <div class="login-code">
              <img :src="codeUrl" @click="getCode" class="code-img" />
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button @click="submit" type="primary">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getCodeImg, submitContactusData } from "@/api/apiRequest";
import Vrouter from "@/router";
const checkPhone = (rule, value, callback) => {
  let reg = /^1[345789]\d{9}$/;
  if (!reg.test(value)) {
    callback(new Error("请输入11位手机号"));
  } else {
    callback();
  }
};
export default {
  name: "Footer",
  data() {
    return {
      codeUrl: "",
      captchaEnabled: true,
      formData: { contenttype: "0" },
      formVisible: false,
      wordkey: "",
      ksmeun: [
        {
          name: "首    页",
          path: "home",
          catalogId: "",
          contentType: "",
          contentId: "",
        },
        {
          name: "服务中心",
          path: "appointment",
          catalogId: "",
          contentType: "",
          contentId: "",
        },
        {
          name: "关于我们",
          path: "companyintroduce",
          catalogId: "390571673047109",
          contentType: "article",
          contentId: "390580083195973",
        },
        {
          name: "公司动态",
          path: "news",
          catalogId: "390567566614597",
          contentType: "",
          contentId: "",
        },
        {
          name: "核心业务",
          path: "hrdispatch",
          catalogId: "435861385666629",
          contentType: "article",
          contentId: "447498973474885",
        },
        {
          name: "联系我们",
          path: "contact",
          catalogId: "435860723699781",
          contentType: "article",
          contentId: "436233160347717",
        },
      ],
      rules: {
        contactustel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            type: "number",
            validator: checkPhone,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请输入留言内容", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  mounted() {},
  methods: {
    scrollToTop() {
      // 页面滚动的动画效果
      window.scrollTo({
        top: 0, // 滚动到页面顶部
        behavior: "smooth", // 平滑滚动
      });
    },
    openPage(item) {
      let queryData = null;
      if (item.contentId != "") {
        queryData = {
          contentType: item.contentType,
          catalogId: item.catalogId,
          contentId: item.contentId,
        };
      } else {
        queryData = { catalogId: item.catalogId };
      }
      this.$router.push({
        name: item.path,
        query: queryData,
      });
      this.scrollToTop();
    },
    getCode() {
      getCodeImg().then((res) => {
        this.captchaEnabled =
          res.data.data.captchaEnabled === undefined
            ? true
            : res.data.data.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.data.data.img;
          this.formData.uuid = res.data.data.uuid;
        }
      });
    },
    guestbook() {
      if (this.formVisible) this.formVisible = false;
      else {
        this.getCode();
        this.formVisible = true;
      }
    },
    closeguestbook() {
      this.formVisible = true;
    },
    reset() {
      this.formData = {
        contactustel: undefined,
        content: undefined,
        contactusname: undefined,
        contactusemail: undefined,
        code: undefined,
      };
    },
    search() {
      if (this.wordkey) {
        let wordkey = { wordkey: this.wordkey };
        this.$router.push({
          name: "searchalldata",
          query: wordkey,
        });
        this.scrollToTop();
      }
    },
    submit() {
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          submitContactusData(this.formData).then((res) => {
            if (res.data.code == 200) {
              this.$confirm("提交成功！", "提示", {
                confirmButtonText: "确定",
                showCancelButton: false,
                closeOnClickModal: false,
                type: "warning",
              }).then(() => {
                this.reset();
                this.formVisible = false;
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 463px;
  color: #fff;
  background-repeat: no-repeat;
  background-image: url(../assets/img/footer.png);
  background-size: cover;
  overflow: hidden;
  text-align: center;
}
.logo img {
  width: 190px;
  height: 56px;
}
.title {
  font-size: 20px;
  margin-bottom: 20px;
  padding-bottom: 7px;
  color: #b0b4b9;
  border-bottom: 1px solid #4e5d78;
}
.title .small {
  font-size: 16px;
  color: #a3a7ab;
  padding-left: 10px;
}
#footer .wrap {
  display: flex;
  width: 1326px;
  margin: 113px auto;
  align-items: start;
  justify-content: space-between;
  text-align: left;
}
.phone {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-image: url(../assets/img/phone1.png);
  background-repeat: no-repeat;
  background-size: contain;
}
.email {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-image: url(../assets/img/email.png);
  background-repeat: no-repeat;
  background-size: contain;
}
.address {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-image: url(../assets/img/address.png);
  background-repeat: no-repeat;
  background-size: contain;
}
.info .content {
  display: flex;
  line-height: 36px;
  align-items: center;
  color: #a3a7ab;
}
.info .content i {
  margin-right: 10px;
}
.links {
  display: inline-grid;
  width: 200px;
  grid-template-columns: 50% 50%;
  grid-template-rows: 35px 35px 35px;
}
.links a,
.links a:hover,
.linkes a:visited {
  color: #a3a7ab !important;
  text-decoration: none;
}
.search-section {
  display: flex;
  margin-top: 40px;
}
.search-section input {
  height: 40px;
  line-height: 40px;
  border-left: 1px solid #4e5d78;
  border-top: 1px solid #4e5d78;
  border-bottom: 1px solid #4e5d78;
  border-right: 0px;
  padding: 0px 16px;
  background-color: transparent;
  border-radius: 4px 0px 0px 4px;
}
.search-btn {
  width: 60px;
  height: 40px;
  line-height: 40px;
  background: #2675d2;
  border-radius: 0px 4px 4px 0px;
  text-align: center;
  cursor: pointer;
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;
}
.code-img {
  height: 50px;
}
.liuyan {
  width: 100px;
  height: 40px;
  position: absolute;
  right: 10px;
  margin-top: -500px;
  font-size: 16px;
  line-height: 40px;
  background-color: #3382dc;
  border-radius: 4px;
  cursor: pointer;
}
.beian {
  width: 382px;
  margin: 0 auto;
  display: flex;
  text-align: center;
}
.beian span:nth-child(1) {
  display: flex;
}
.beian span:nth-child(2) {
  padding-left: 15px;
}
@media screen and (min-width: 996px) and (max-width: 1400px) {
  #footer .wrap {
    display: flex;
    width: 100%;
    margin: 113px auto;
    align-items: start;
    justify-content: space-between;
    text-align: left;
  }
}
@media screen and (max-width: 767px) {
  .comments-box {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
  }
  #footer {
    height: auto;
    padding: 0 30px;
  }
  #footer .wrap {
    width: 100%;
    flex-direction: column;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  #footer .wrap > div {
    width: 100%;
    margin-top: 30px;
  }
  #footer .wrap .search {
    display: flex;
    flex-flow: column-reverse;
  }
  .search-section {
    margin-top: 0px;
    margin-bottom: 20px;
  }
  .beian {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    justify-content: start;
  }
  .beian span:nth-child(2) {
    text-align: left;
    padding-left: 18px;
  }
  .liuyan {
    margin-top: -720px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue